module.exports = __webpack_public_path__ + "static/fundwall_1-c54b8c62ca3ef7fe17ef794cb5452d12.jpg";